module.exports = __webpack_public_path__ + "static/media/Star_vector.bbab099c.svg";